import { z } from 'zod';
import { FullColumnName } from '@models/column';

export type OnlyColumnFields<T> = {
  [K in keyof T as T[K] extends FullColumnName ? K : never]: T[K];
};

export const ColumnDraft = z
  .object(
    {
      table: z.string(),
      name: z.string(),
    },
    { description: 'Column' }
  )
  .transform(FullColumnName.create);

export const NumberDraft = z
  .union([
    z.literal('inf'),
    z.literal('-inf'),
    z.number(),
    z
      .string()
      .refine(val => val !== '' && !isNaN(Number(val)), {
        message: "Invalid value, must be a number or 'inf' or '-inf'",
      }),
  ])
  .transform(val => {
    if (val === 'inf') return 'inf';
    if (val === '-inf') return -'-inf';
    return Number(val);
  });
